/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number } from 'prop-types'

const MarketingGoalsArrow = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      {...props}
    >
      <path
        d="M12.3107 5.80859C12.0607 5.56445 11.6554 5.56445 11.4057 5.80859C11.1561 6.05273 11.1557 6.44844 11.4057 6.69219L14.1551 9.375H6.73766C6.38559 9.375 6.09753 9.65625 6.09753 10C6.09753 10.3438 6.38383 10.625 6.73766 10.625H14.1551L11.4069 13.3082C11.1569 13.5523 11.1569 13.948 11.4069 14.1918C11.657 14.4355 12.0623 14.4359 12.3119 14.1918L16.1526 10.4418C16.2755 10.3203 16.3395 10.1602 16.3395 10C16.3395 9.83984 16.277 9.68016 16.1519 9.5582L12.3107 5.80859ZM11.2185 0C5.56143 0 0.976562 4.47656 0.976562 10C0.976562 15.5234 5.56143 20 11.2185 20C16.8756 20 21.4604 15.5234 21.4604 10C21.4604 4.47656 16.8756 0 11.2185 0ZM11.2185 18.75C6.27757 18.75 2.25681 14.8242 2.25681 10C2.25681 5.17578 6.27757 1.25 11.2185 1.25C16.1594 1.25 20.1802 5.17578 20.1802 10C20.1802 14.8242 16.1594 18.75 11.2185 18.75Z"
        fill="#05A58A"
      />
    </svg>
  )
}

MarketingGoalsArrow.propTypes = {
  size: number,
}

export default MarketingGoalsArrow
